module.exports = __webpack_public_path__ + "static/apple-icon-180x180-7decd1c4626124b625659be1e92e8dbe.png";